<template>
  <div class="d-flex align-items-center">
    <div class="comment-avatar mr-2 mr-sm-4">
      <img
        class="rounded-circle"
        loading="lazy"
        width="100"
        height="100"
        alt="user-avatar"
        :src="user.avatar"
      >
    </div>
    <div class="info break-word-all">
      <h4 class="name h3">
        {{ founderName }}
      </h4>
      <div class="title">
        {{ user.title }}
      </div>
      <div
        v-if="productUrl"
        class="url"
      >
        <a
          :href="productUrl.value"
          target="_blank"
        >
          {{ productUrl.label }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productUrl: {
      type: Object,
      default: null,
    },
    isSelect: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isVerified: this.isSelect && this.user.email_verified,
    };
  },
  computed: {
    founderName() {
      const { first_name: fName, last_name: lName, username } = this.user;
      return `${fName || ''} ${lName || ''}`.trim() || username;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~/styles/dorado/main'; // TODO -- Remove once auto imported

  .founder-container {
    background-color: $gray-100;
  }

  .comment-avatar img {
    width: 90px;
    height: 90px;
    object-fit: cover;
  }

  .url > a {
    text-decoration: underline;

    &:hover {
      color: $deep-ocean;
    }
  }

  .name {
    color: $black-pearl;
    margin-bottom: 2px;
  }

  .title {
    color: $grace;
    font-size: $font-size-base;
    font-family: $font-family-base;
  }

  @media screen and (max-width: 767px) {
    .comment-avatar img {
      width: 65px;
      height: 65px;
    }

    .name {
      font-size: $font-size-base;
    }

    .title,
    .url > a {
      font-size: 0.9rem;
    }
  }
</style>
